export interface UserCommunicationsModel {
  showSurveyNotifications: boolean;
  showUpdatesInspirationOffers: boolean;
}
